import React, { useContext, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Badge,
  Box,
  CardActions,
  CardContent,
  Checkbox, FormControl,
  FormControlLabel,
  IconButton, MenuItem, Select,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import { displayedReplies } from '../../containers/CommentBox/commentOrder';
import ReadOnlyQuillEditor from '../TextEditors/ReadOnlyQuillEditor';
import {
  ISSUE_TYPE,
  JUSTIFY_TYPE,
  QUESTION_TYPE,
  REPLY_TYPE,
  REPORT_TYPE,
  SUGGEST_CHANGE_TYPE,
  TODO_TYPE,
} from '../../constants/comments';
import { alterComment, reopenComment, resolveComment, updateComment } from '../../api/comments';
import { OperationInProgressContext } from '../../contexts/OperationInProgressContext/OperationInProgressContext';
import { MarketPresencesContext } from '../../contexts/MarketPresencesContext/MarketPresencesContext';
import {
  changeMyPresence, getGroupPresences, usePresences
} from '../../contexts/MarketPresencesContext/marketPresencesHelper';
import CommentEdit from './CommentEdit';
import { useInlineWizardLaunch } from '../InlineWizard/InlineWizardContext';
import { MarketsContext } from '../../contexts/MarketsContext/MarketsContext';
import { addMarketToStorage, getMarket, marketTokenLoaded } from '../../contexts/MarketsContext/marketsContextHelper';
import CardType, { BUG, DECISION_TYPE, NOTE } from '../CardType';
import {
  addCommentToMarket, addMarketComments, getComment,
  getMarketComments, getOpenInvestibleComments, moveToDiscussion
} from '../../contexts/CommentsContext/commentsContextHelper';
import { CommentsContext } from '../../contexts/CommentsContext/CommentsContext';
import {
  ACTIVE_STAGE,
  BUG_WIZARD_TYPE, DELETE_COMMENT_TYPE, IN_PROGRESS_WIZARD_TYPE,
  INITIATIVE_TYPE,
  JOB_COMMENT_CONFIGURE_WIZARD_TYPE,
  JOB_COMMENT_WIZARD_TYPE,
  OPTION_WIZARD_TYPE,
  PLANNING_TYPE,
  REPLY_WIZARD_TYPE
} from '../../constants/markets';
import { red } from '@material-ui/core/colors';
import UsefulRelativeTime from '../TextFields/UseRelativeTime';
import {
  getInvestible,
  getMarketInvestibles
} from '../../contexts/InvestibesContext/investiblesContextHelper';
import { InvestiblesContext } from '../../contexts/InvestibesContext/InvestiblesContext';
import {
  getFullStage,
  getFurtherWorkStage,
  getInReviewStage, getNotDoingStage,
  getProposedOptionsStage
} from '../../contexts/MarketStagesContext/marketStagesContextHelper';
import { MarketStagesContext } from '../../contexts/MarketStagesContext/MarketStagesContext';
import {
  decomposeMarketPath,
  formCommentLink,
  formInvestibleAddCommentLink,
  formMarketAddInvestibleLink,
  formWizardLink,
  navigate,
  preventDefaultAndProp
} from '../../utils/marketIdPathFunctions';
import { useHistory, useLocation } from 'react-router';
import { marketAbstain } from '../../api/markets';
import {
  changeInvestibleStage, changeInvestibleStageOnCommentClose,
  handleAcceptSuggestion,
  isAIAuthoredQuestionWithOptions,
  isSingleAssisted,
  moveToTaskPayload,
  onCommentOpen, onCommentsMove
} from '../../utils/commentFunctions';
import { NotificationsContext } from '../../contexts/NotificationsContext/NotificationsContext';
import {
  findMessageForCommentId,
  removeInlineMarketMessages,
  removeMessagesForCommentId
} from '../../utils/messageUtils';
import GravatarAndName from '../Avatars/GravatarAndName';
import { invalidEditEvent } from '../../utils/windowUtils';
import AddIcon from '@material-ui/icons/Add';
import SpinningIconLabelButton from '../Buttons/SpinningIconLabelButton';
import MenuButton from '../Buttons/MenuButton';
import {
  Done,
  Edit,
  Eject,
  ExpandLess,
  NotificationsActive,
  NotInterested,
  SettingsBackupRestore,
  UnfoldMore
} from '@material-ui/icons';
import ReplyIcon from '@material-ui/icons/Reply';
import TooltipIconButton from '../Buttons/TooltipIconButton';
import { getPageReducerPage, usePageStateReducer } from '../PageState/pageStateHooks';
import InlineInitiativeBox from '../../containers/CommentBox/InlineInitiativeBox';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { EditCommentContext } from '../../contexts/EditCommentContext/EditCommentContext';
import { getDiff } from '../../contexts/DiffContext/diffContextHelper';
import useCommentDiff from './useCommentDiff';
import { DiffContext } from '../../contexts/DiffContext/DiffContext';
import DiffDisplay from '../TextEditors/DiffDisplay';
import LoadingDisplay from '../LoadingDisplay';
import { pushMessage } from '../../utils/MessageBusUtils';
import { GUEST_MARKET_EVENT, LOAD_MARKET_CHANNEL } from '../../contexts/MarketsContext/marketsContextMessages';
import { SearchResultsContext } from '../../contexts/SearchResultsContext/SearchResultsContext';
import { userIsLoaded } from '../../contexts/AccountContext/accountUserContextHelper';
import InvesibleCommentLinker from '../../pages/Dialog/InvesibleCommentLinker';
import { AccountContext } from '../../contexts/AccountContext/AccountContext';
import { ScrollContext } from '../../contexts/ScrollContext';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import SettingsIcon from '@material-ui/icons/Settings';
import Options from './Options';
import Reply from './Reply';
import CommentTypeChip from './CommentTypeChip';
import { isLargeDisplay, stripHTML } from '../../utils/stringFunctions';
import Gravatar from '../Avatars/Gravatar';
import styled from 'styled-components';
import { BLUE_LEVEL, NOT_FULLY_VOTED_TYPE, RED_LEVEL, UNASSIGNED_TYPE } from '../../constants/notifications';
import NotificationDeletion from '../../pages/Home/YourWork/NotificationDeletion';
import { getInboxTarget } from '../../contexts/NotificationsContext/notificationsContextHelper';
import EditIcon from '@material-ui/icons/Edit';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { hasReply } from '../AddNewWizards/Reply/ReplyStep';
import { previousInProgress } from '../AddNewWizards/TaskInProgress/TaskInProgressWizard';
import { getMarketClient } from '../../api/marketLogin';
import { isMyPokableComment } from '../../pages/Home/YourWork/InboxExpansionPanel';
import { GroupMembersContext } from '../../contexts/GroupMembersContext/GroupMembersContext';
import { MarketGroupsContext } from '../../contexts/MarketGroupsContext/MarketGroupsContext';
import { ThemeModeContext } from '../../contexts/ThemeModeContext';
import { ACTION_BUTTON_COLOR, DARK_INFO_COLOR, DARK_TEXT_BACKGROUND_COLOR } from '../Buttons/ButtonConstants';
import CondensedTodos from '../../pages/Investible/Planning/CondensedTodos';
import PokeAIButton, { isPokeAICommentType } from '../Buttons/PokeAIButton';

// On the Notes tab a note's day header is bucketed by the note's own tz (getLocalDayKey with
// note.tz, per Q-all-59) so a note's day does not move when the viewer travels. The mobile card
// date must render in that same tz or the header and card disagree (B-all-459) - traveling to a
// far tz otherwise buckets a note under one day while its card shows the next. Everywhere else the
// viewer's local tz is correct, so only the Notes tab passes a tz.
function formatCommentDate(intl, comment, inNotesTab) {
  if (inNotesTab && !_.isEmpty(comment.tz)) {
    try {
      return intl.formatDate(comment.updated_at, { timeZone: comment.tz });
    } catch {
      // Invalid/unknown tz - fall through to the viewer's local formatting.
    }
  }
  return intl.formatDate(comment.updated_at);
}

// Preview this many lines. isLargeDisplay uses the same allowance, so compression
// starts only after the preview is full.
const COMPRESSED_PREVIEW_LINES = 7;

export const useCommentStyles = makeStyles(
  theme => {
    return {
      chip: {
        margin: 0,
        marginBottom: 18
      },
      content: {
        marginTop: '12px',
        fontSize: 15,
        lineHeight: "175%"
      },
      cardContent: {
        paddingTop: 0,
        paddingRight: "20px",
        paddingLeft: "20px",
        paddingBottom: "0.75rem",
        overflowY: 'hidden'
      },
      cardActions: {
        padding: "8px"
      },
      actionsEnd: {
        display: "flex",
        justifyContent: "flex-end",
        boxShadow: "none",
        width: "100%"
      },
      actions: {
        display: "flex",
        boxShadow: "none",
        width: "100%"
      },
      action: {
        boxShadow: "none",
        fontSize: 12,
        padding: "4px 16px, 0, 0",
        textTransform: "none",
        "&:hover": {
          boxShadow: "none"
        }
      },
      actionPrimary: {
        backgroundColor: '#2D9CDB',
        color: 'white',
        textTransform: 'unset',
        padding: 0,
        marginRight: '20px',
        '&:hover': {
          backgroundColor: '#e0e0e0'
        },
        '&:disabled': {
          color: 'white',
          backgroundColor: 'rgba(45, 156, 219, .6)'
        }
      },
      actionSecondary: {
        backgroundColor: '#e0e0e0',
        textTransform: 'unset',
        padding: 0,
        marginRight: '20px',
        '&:hover': {
          backgroundColor: '#F1F1F1'
        }
      },
      actionWarned: {
        backgroundColor: "#BDBDBD",
        color: "black",
        "&:hover": {
          backgroundColor: red["400"],
        }
      },
      updatedBy: {
        alignSelf: "baseline",
        color: "#434343",
        fontWeight: "bold",
        fontSize: 12,
        lineHeight: 1.75,
        marginLeft: "auto"
      },
      actionResolveToggle: {
        margin: "11px 12px 11px 16px",
        [theme.breakpoints.down('sm')]: {
          margin: "11px 6px 11px 3px",
        },
      },
      actionEdit: {
        alignSelf: "baseline",
        margin: "11px 0px 11px 16px",
        [theme.breakpoints.down('sm')]: {
          margin: "11px 0px 11px 3px",
        },
      },
      commentType: {
        // T-all-2220: was alignSelf:'start', which pinned the type chip to the top of the header
        // row above the centered author/timestamp/icon line. Let it center with the row instead.
        display: "inline-flex"
      },
      smallGravatar: {
        width: '30px',
        height: '30px',
        marginTop: '2px'
      },
      createdBy: {
        fontSize: '15px',
        color: 'black',
        whiteSpace: 'nowrap'
      },
      childWrapper: {
        // borderTop: '1px solid #DCDCDC',
      },
      initialComment: {
        display: "flex"
      },
      avatarWrapper: {
        marginRight: "20px"
      },
      selectIcon: {
        color: 'black'
      },
      containerRed: {
        boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px red",
        overflow: "visible",
        marginTop: "0.5rem"
      },
      containerYellow: {
        boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px yellow",
        overflow: "visible",
        marginTop: "0.5rem"
      },
      containerBlueLink: {
        // Clickable compressed comment/task card in wizards + inbox: the clean
        // rounded card from T-all-2178, but with a blue (link) border so it
        // reads as clickable/click-through instead of looking like a static
        // card - the gray border lost that affordance (T-all-2181, Q-all-154
        // O-1). Hover deepens the blue and adds a soft blue glow.
        overflow: "visible",
        marginTop: "0.5rem",
        cursor: 'pointer',
        borderRadius: '8px',
        border: '1px solid #2F80ED',
        boxShadow: '0 1px 3px rgba(16, 40, 40, 0.14)',
        "&:hover": {
          border: '1px solid #1565C0',
          boxShadow: '0 1px 8px 0 rgba(47, 128, 237, 0.4)'
        }
      },
      containerWhite: {
        backgroundColor: "white",
        overflow: "visible",
        marginTop: "1.5rem"
      },
      containerHashYellow: {
        backgroundColor: "#FBF6D8",
        overflow: "visible",
        marginTop: "1.5rem",
        cursor: 'pointer'
      },
      containerLink: {
        overflow: "visible",
        cursor: 'pointer'
      },
      container: {
        overflow: "visible",
        marginTop: "1.5rem"
      },
      timeElapsed: {
        whiteSpace: 'nowrap',
        color: theme.palette.type === 'dark' ? '#8E8E8E' : '#A7A7A7',
        paddingRight: '10px',
        paddingTop: '5px'
      },
      todoLabelType: {
        [theme.breakpoints.down('sm')]: {
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto'
        }
      },
      commentTypeGroup: {
        display: "flex",
        flexDirection: "row",
        [theme.breakpoints.down('sm')]: {
          display: 'block'
        }
      },
      chipItem: {
        color: '#fff',
        borderRadius: '8px',
        '& .MuiChip-label': {
          fontSize: 12,
        },
        '& .MuiFormControlLabel-label': {
          paddingRight: '5px',
          fontWeight: 'bold',
          textTransform: 'capitalize',
          [theme.breakpoints.down('sm')]: {
            height: '100%',
            verticalAlign: 'middle',
            display: 'inline-block',
            '& .MuiSvgIcon-root': {
              display: 'block'
            }
          },
        },
        '& .MuiChip-avatar': {
          width: '16px',
          height: '14px',
          color: '#fff',
        },
        '& .MuiRadio-colorPrimary.Mui-checked':{
          '&.Mui-checked': {
            color: 'white'
          }
        },
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        margin: theme.spacing(0, 0, 0, 4),
        [theme.breakpoints.down('sm')]: {
          margin: '10px'
        },
      },
      selected: {
        opacity: 1
      },
      unselected: {
        opacity: '.6'
      },
      chipItemQuestion: {
        background: '#2F80ED',
      },
      chipItemIssue: {
        background: '#E85757',
        color: 'black'
      },
      chipItemSuggestion: {
        background: '#e6e969',
        color: 'black'
      },
      commentTypeContainer: {
        borderRadius: '4px 4px 0 0'
      },
      button: {
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: 'bold',
        margin: 8
      },
      compressedComment: {
        paddingLeft: '1rem',
        paddingTop: '0.25rem',
        color: 'black',
        display: '-webkit-box',
        WebkitLineClamp: COMPRESSED_PREVIEW_LINES,
        WebkitBoxOrient: 'vertical',
        whiteSpace: 'normal',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
        flex: '1 1 auto',
        minWidth: 0,
        paddingRight: '0.5rem',
        marginRight: '0.5rem',
        marginTop: '0.25rem'
      },
      rootCheckbox: {
        color: 'black',
        opacity: 0.54,
        padding: '4px',
        // The dark theme's disabled color is faint white, invisible on the light card - keep the
        // forced-checked disabled "Show AI" check mark black so it can be seen (T-all-2244).
        '&.Mui-disabled': {
          color: theme.palette.type === 'dark' ? 'black' : undefined,
        },
      },
      checkedCheckbox: {
        opacity: 1,
      },
      formControlLabel: {
        '& .MuiFormControlLabel-label.Mui-disabled': {
          color: theme.palette.type === 'dark' ? 'rgba(0, 0, 0, 0.38)' : undefined,
        },
      },
  }
},
{ name: "Comment" }
);


export const LocalCommentsContext = React.createContext(null);

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    marginRight: 4,
    marginLeft: 8
  },
  '& .MuiBadge-anchorOriginTopRightRectangle': {
    paddingTop: '3px'
  }
}));

function getCompressionButton(numberHidden, inboxMessageId, toggleCompression, intl) {
  return (
    <IconButton id={`removeCompressed${inboxMessageId}`} onClick={toggleCompression}
                style={{border: '1px solid grey', marginTop: -11, marginBottom: -11}}>
      <Tooltip key={`tipCompressed${inboxMessageId}`}
               title={intl.formatMessage({ id: 'removeCompressionExplanation' })}>
        <StyledBadge badgeContent={numberHidden} style={{paddingRight: '7px'}} >
          <UnfoldMore />
        </StyledBadge>
      </Tooltip>
    </IconButton>
  );
}

function InitialReply(props) {
  const { comment, enableEditing, replyEditId, inboxMessageId, isInbox, wizardProps,
    numberHidden = 0, useCompression, toggleCompression, myPresenceIsAssigned, enableActions, isDeletable } = props;
  const intl = useIntl();
  if (numberHidden > 0) {
    return (
      <>
        {getCompressionButton(numberHidden, inboxMessageId, toggleCompression, intl)}
        <Reply comment={comment} enableEditing={enableEditing} replyEditId={replyEditId}
               useCompression={useCompression} toggleCompression={toggleCompression}
               myPresenceIsAssigned={myPresenceIsAssigned}
               enableActions={enableActions}
               isDeletable={isDeletable}
               inboxMessageId={inboxMessageId} isInbox={isInbox} wizardProps={wizardProps}/>
      </>
    );
  }
  return <Reply comment={comment} enableEditing={enableEditing} replyEditId={replyEditId}
                useCompression={useCompression} toggleCompression={toggleCompression}
                myPresenceIsAssigned={myPresenceIsAssigned}
                enableActions={enableActions}
                isDeletable={isDeletable}
                inboxMessageId={inboxMessageId} isInbox={isInbox} wizardProps={wizardProps}/>;
}

function calculateNumberHidden(comment, inboxMessageId, comments, parent) {
  const wholeThreadBelow = comments.filter((aComment) => aComment.root_comment_id === comment.id &&
    aComment.id !== comment.id);
  const sizeWholeThreadBelow = _.size(wholeThreadBelow);
  if (!inboxMessageId) {
    return sizeWholeThreadBelow;
  }
  let notifiedDescendants = [];
  let immediateDescendants = comments.filter((aComment) => aComment.reply_id === inboxMessageId);
  while(_.size(immediateDescendants) > 0) {
    notifiedDescendants = notifiedDescendants.concat(immediateDescendants);
    const immediateDescendantIds = immediateDescendants.map((aComment) => aComment.id);
    immediateDescendants = comments.filter((aComment) => immediateDescendantIds.includes(aComment.reply_id));
  }
  const sizeThreadNotBelowNotified = sizeWholeThreadBelow - _.size(notifiedDescendants);
  return parent.id === inboxMessageId ? sizeThreadNotBelowNotified - 1 : sizeThreadNotBelowNotified - 2;
}

function findParentInDescendants(useComment, inboxMessageId, comments) {
  const notifiedComment = comments.find((comment) => comment.id === inboxMessageId);
  const notifiedParentId = notifiedComment?.reply_id;
  if (notifiedParentId === notifiedComment?.root_comment_id) {
    if (useComment.id === inboxMessageId) {
      // If this is a reply to the root then return it
      return notifiedComment;
    }
    return undefined;
  }
  const notifiedParent = comments.find((comment) => comment.id === notifiedParentId);
  let found = false;
  let commentPointer = notifiedParent;
  while(commentPointer?.reply_id) {
    if (useComment.id === commentPointer.id) {
      found = true;
      break;
    }
    // eslint-disable-next-line no-loop-func
    commentPointer = comments.find((comment) => comment.id === commentPointer.reply_id);
  }
  return found ? notifiedParent : undefined;
}

function isSubTask(comment, commentsState, isPlanning) {
  if (!isPlanning || comment.comment_type !== REPLY_TYPE) {
    return false;
  }
  const parent = getComment(commentsState, comment.market_id, comment.reply_id);
  if (!parent) {
    return false;
  }
  if (parent.comment_type !== TODO_TYPE) {
    return false;
  }
  // A reply authored by someone other than the task author is still a grouped subtask when it
  // carries the BLUE notification level - REPLY + BLUE uniquely identifies a grouped task/note.
  return parent.created_by === comment.created_by || comment.notification_type === BLUE_LEVEL;
}

/**
 * A question or issue
 * @param {{comment: Comment, comments: Comment[]}} props
 */
function Comment(props) {
  const { comment, marketId, comments, noAuthor = false, reallyNoAuthor, isReply, wizardProps, investibleComments,
    resolvedStageId, stagePreventsActions, isInbox, replyEditId, currentStageId, marketInfo, investible, removeActions,
    inboxMessageId, toggleCompression: toggleCompressionRaw, useCompression, showVoting, selectedInvestibleIdParent,
    isMove, idPrepend='c', usePadding=true, compressAll=false, focusMove=false, showNotes=false,
    inNotesTab=false, pokeAIMarketId, pokeAIParentTicketCode } = props;
  const history = useHistory();
  const location = useLocation();
  const { openInlineWizard } = useInlineWizardLaunch();
  const editBox = useRef(null);
  const [themeMode] = React.useContext(ThemeModeContext);
  const isDark = themeMode === 'dark';
  const theme = useTheme();
  const isReallyMobileLayout = useMediaQuery(theme.breakpoints.down('xs'));
  const mobileLayout = useMediaQuery(theme.breakpoints.down('md'));
  const mediumLayout = useMediaQuery('(min-width:1400px)');
  const [commentsState, commentsDispatch] = useContext(CommentsContext);
  const [groupPresencesState] = useContext(GroupMembersContext);
  const [groupsState] = useContext(MarketGroupsContext);
  const intl = useIntl();
  const classes = useCommentStyles();
  const { id, comment_type: commentType, investible_id: investibleId, inline_market_id: inlineMarketId,
    resolved, notification_type: myNotificationType, body, is_sent: isSent, group_id: groupId,
    in_progress: inProgress, is_visible: isVisible } = comment;
  const isNote = commentType === REPORT_TYPE && (_.isEmpty(investibleId) || myNotificationType === 'BLUE');
  const isCapsule = comment.pinned === true;
  const { pathname } = location;
  const { marketId: typeObjectIdRaw, action } = decomposeMarketPath(pathname);
  const typeObjectId = action === 'inbox' ? typeObjectIdRaw : undefined;
  const beingEdited = replyEditId === id;
  const replyBeingEdited = beingEdited && isReply;
  const thisCommentBeingEdited = beingEdited && !replyBeingEdited;
  const presences = usePresences(marketId);
  const inlinePresences = usePresences(inlineMarketId);
  const isSingleUser = _.size(presences) < 2;
  const createdBy = useCommenter(comment, presences) || unknownPresence;
  const updatedBy = useUpdatedBy(comment, presences) || unknownPresence;
  const [marketsState, marketDispatch, tokensHash] = useContext(MarketsContext);
  const inlineMarket = getMarket(marketsState, inlineMarketId) || {};
  const market = getMarket(marketsState, marketId) || {};
  const { market_stage: marketStage, market_type: marketType } = market;
  const activeMarket = marketStage === ACTIVE_STAGE;
  const myPresence = presences.find((presence) => presence.current_user) || {};
  const { assigned: invAssigned } = marketInfo || {};
  const assigned = invAssigned || [];
  const myPresenceIsAssigned = assigned.includes(myPresence.id);
  const myInlinePresence = inlinePresences.find((presence) => presence.current_user) || {};
  const inArchives = !activeMarket;
  const sortedReplies = displayedReplies(comment, comments);
  const [operationRunning, setOperationRunning] = useContext(OperationInProgressContext);
  const [marketPresencesState, presenceDispatch] = useContext(MarketPresencesContext);
  const [investiblesState, investiblesDispatch] = useContext(InvestiblesContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [messagesState, messagesDispatch] = useContext(NotificationsContext);
  const [diffState] = useContext(DiffContext);
  const [searchResults] = useContext(SearchResultsContext);
  const [userState] = useContext(AccountContext);
  const [hashFragment, noHighlightId, setNoHighlightId] = useContext(ScrollContext);
  const hasUser = userIsLoaded(userState, marketsState);
  const enableActions = !inArchives && !stagePreventsActions && !removeActions;
  const enableEditing = enableActions && !resolved; //resolved comments or those in archive aren't editable
  const { editComment, openEditComment, closeEditComment } = useContext(EditCommentContext);
  const [editStateFull, editDispatch] = usePageStateReducer('commentEdit');
  const [editState, updateEditState, editStateReset] = getPageReducerPage(editStateFull, editDispatch, id);
  const {
    showDiff: storedShowDiff
  } = editState;
  const [showDiff, toggleDiff] = useCommentDiff(comment, marketId, location, storedShowDiff, updateEditState);
  const myMessage = findMessageForCommentId(id, messagesState.messages);
  const inReviewStage = getInReviewStage(marketStagesState, marketId) || {};
  const inReviewStageId = inReviewStage.id;
  const inBacklogStage = getFurtherWorkStage(marketStagesState, marketId) || {};
  const inBacklog = currentStageId === inBacklogStage.id;
  const createdInReview = currentStageId === inReviewStageId;
  const loading = !hasUser || !myPresence || !marketType || !marketTokenLoaded(marketId, tokensHash)
    || (inlineMarketId && _.isEmpty(inlineMarket));
  const notDoingStage = getNotDoingStage(marketStagesState, marketId) || {};
  const otherInProgress = previousInProgress(myPresence.id, comment, investiblesState, commentsState, notDoingStage.id);
  const isDisplayOfSubTask = isSubTask(comment, commentsState, marketType === PLANNING_TYPE);
  const thisIsMyNote = createdBy === myPresence && isNote;
  // A note that has a reply is always shown to the AI (the back end already includes such notes in the
  // MD), so lock its "Show AI" checkbox on - see T-all-2242.
  const noteHasReply = isNote && !_.isEmpty(sortedReplies);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (inlineMarketId && !marketsState.initializing && hasUser && !operationRunning) {
      const inlineMarketLoaded = getMarket(marketsState, inlineMarketId);
      if (_.isEmpty(inlineMarketLoaded)) {
        // Eventual consistency means there is a chance we were not invited to this inline market
        pushMessage(LOAD_MARKET_CHANNEL, { event: GUEST_MARKET_EVENT, marketId: inlineMarketId });
      }
    }
  }, [hasUser, marketsState, inlineMarketId, operationRunning]);

  function toggleCompression() {
    toggleCompressionRaw(id);
  }

  function toggleDiffShow(event) {
    preventDefaultAndProp(event)
    toggleDiff();
  }

  function toggleEdit(event) {
    preventDefaultAndProp(event);
    if (replyEditId) {
      // Closing the editor (Update/Cancel, or re-clicking edit). When this comment
      // is open in the top-level edit modal (T-all-2209 / Q-all-156 O-2) just close
      // it; otherwise fall back to the standalone /comment page navigation.
      setNoHighlightId(undefined);
      if (editComment?.commentId === id && closeEditComment) {
        closeEditComment();
      } else {
        navigate(history, formCommentLink(marketId, groupId, investibleId, id));
      }
    } else {
      // Opening the editor: open the top-level modal (decoupled from this row so it
      // survives the task moving jobs mid-edit). Fall back to the /comment page if
      // the context is somehow unavailable.
      setNoHighlightId(id);
      if (openEditComment) {
        openEditComment(marketId, id);
      } else {
        navigate(history, `/comment/${marketId}/${id}`, false, true);
      }
    }
  }

  function setBeingEdited(event) {
    if (isReallyMobileLayout || invalidEditEvent(event)) {
      return;
    }
    toggleEdit(event);
  }

  const isMarketTodo = marketType === PLANNING_TYPE && commentType === TODO_TYPE && !investibleId && !isMove;
  const isTask = marketType === PLANNING_TYPE && commentType === TODO_TYPE && investibleId;
  const isInfo = marketType === DECISION_TYPE && commentType === TODO_TYPE && investibleId;
  // Per C-all-1167 an AI authored comment grants author rights to any collaborator - the AI user
  // is the only presence without an email
  const isAiAuthored = !!createdBy.id && _.isEmpty(createdBy.email);
  const inlineInvestibles = getMarketInvestibles(investiblesState, inlineMarketId);
  const isDelegate = isAIAuthoredQuestionWithOptions(comment, marketPresencesState[marketId], inlineInvestibles);
  const isEditable = comment.created_by === myPresence.id || isAiAuthored || isMarketTodo ||
    (isTask && myPresenceIsAssigned);

  function getDialog(anInlineMarket) {
    return (
      <Options anInlineMarket={anInlineMarket} marketId={marketId} investibleId={investibleId} inArchives={inArchives}
               isEditable={isEditable || myPresenceIsAssigned} isSent={isSent} groupId={groupId} 
               removeActions={removeActions} isInbox={isInbox} selectedInvestibleIdParent={selectedInvestibleIdParent} 
               searchResults={searchResults} useCompression={useCompression}
               parentCommentResolved={resolved} />
    );
  }

  function getDecision(aMarketId) {
    const anInlineMarket = getMarket(marketsState, aMarketId);
    if (!anInlineMarket) {
      return React.Fragment;
    }
    const { parent_comment_id: parentCommentId, market_stage: marketStage, market_type: marketType } = anInlineMarket;
    if (!parentCommentId || (removeActions && !showVoting)) {
      return React.Fragment;
    }
    if (marketType === INITIATIVE_TYPE) {
      return <InlineInitiativeBox anInlineMarket={anInlineMarket} removeActions={removeActions} isInbox={isInbox}
                                  isTaskDisplay={commentType === TODO_TYPE} typeObjectId={typeObjectId} createdBy={createdBy}
                                  inArchives={marketStage !== ACTIVE_STAGE || inArchives || resolved} />;
    }
    return getDialog(anInlineMarket);
  }

  function reopen() {
    return reopenComment(marketId, id)
      .then((comment) => {
        if (inlineMarket?.market_type === DECISION_TYPE && comment.market_id === inlineMarketId) {
          if (commentType === ISSUE_TYPE) {
            const proposedStage = getProposedOptionsStage(marketStagesState, inlineMarketId);
            const inv = getInvestible(investiblesState, investibleId) || {};
            const [info] = (inv.market_infos || []);
            const { stage } = (info || {});
            if (proposedStage && stage !== proposedStage.id) {
              changeInvestibleStage(proposedStage, assigned, comment.updated_at, info, inv.market_infos, inv.investible,
                investiblesDispatch);
            }
          }
        } else {
          onCommentOpen(investiblesState, investibleId, marketStagesState, marketId, comment, investiblesDispatch,
            commentsState, commentsDispatch, myPresence);
        }
        if (!_.isEmpty(inlineMarket) && inlineMarket.market_stage !== 'Active') {
          // re-open inline market
          const newInlineMarket = {...inlineMarket, market_stage: 'Active'};
          addMarketToStorage(marketDispatch, newInlineMarket);
        }
        // The only message that will be there is the one telling you the comment was resolved
        removeMessagesForCommentId(id, messagesState);
        setOperationRunning(false);
      });
  }

  function abstain(abstain) {
    setOperationRunning(true);
    return marketAbstain(inlineMarketId, abstain)
      .then(() => {
        const newValues = {
          abstain,
        }
        changeMyPresence(marketPresencesState, presenceDispatch, inlineMarketId, newValues)
        removeMessagesForCommentId(id, messagesState)
        setOperationRunning(false);
        if (isInbox) {
          navigate(history, getInboxTarget());
        }
      });
  }

  function resolve() {
    return resolveComment(marketId, id)
      .then((comment) => {
        addCommentToMarket(comment, commentsState, commentsDispatch);
        const isTriage = typeObjectIdRaw?.startsWith('UNASSIGNED_');
        let criticalCommentsNumber = 0;
        if (isTriage) {
          const marketComments = getMarketComments(commentsState, marketId, groupId);
          criticalCommentsNumber = _.size(marketComments?.filter((comment) => comment.comment_type === TODO_TYPE &&
            !comment.investible_id && comment.notification_type === RED_LEVEL && !comment.resolved));
        }
        removeMessagesForCommentId(id, messagesState);
        if (inlineMarketId) {
          removeInlineMarketMessages(inlineMarketId, investiblesState, commentsState, messagesState, messagesDispatch);
        }
        const resolvedStage = resolvedStageId && getFullStage(marketStagesState, marketId, resolvedStageId);
        if (resolvedStage) {
          // J-all-487: the shared guess, which is put back if the server does not confirm it
          changeInvestibleStage(resolvedStage, assigned, comment.updated_at, marketInfo, investible.market_infos,
            investible.investible, investiblesDispatch);
        }
        setOperationRunning(false);
        if (isInbox || criticalCommentsNumber === 1) {
          navigate(history, getInboxTarget());
        }
      });
  }

  function handleToggleInProgress() {
    setOperationRunning(`inProgressCheckbox${id}`);
    const sendToWizard = !inProgress && !_.isEmpty(otherInProgress);
    return updateComment({marketId, commentId: id, inProgress: !inProgress}).then((comment) => {
      setOperationRunning(false);
      addCommentToMarket(comment, commentsState, commentsDispatch)
      if (sendToWizard) {
        navigate(history, formWizardLink(IN_PROGRESS_WIZARD_TYPE, marketId, undefined, undefined, id));
      }
    });
  }

  function handleToggleIsVisible() {
    setOperationRunning(`isVisibleCheckbox${id}`);
    return updateComment({marketId, commentId: id, isVisible: !isVisible}).then((comment) => {
      setOperationRunning(false);
      addCommentToMarket(comment, commentsState, commentsDispatch);
    });
  }

  const diff = getDiff(diffState, id);
  // The "comment label" (the small colored chip rendered by CardType) is only displayed when it
  // adds information beyond the tab the user is already on. On the Notes tab every note is
  // implicitly a note, so the "Note" label is redundant - suppress it. Tasks on the Notes tab
  // are the exception (sub-header expansions) and should make their type explicit with a "Task"
  // label so users can tell the sub-header apart from the notes below it. Symmetric to how the
  // Tasks tab today shows "Note" labels on associated notes but no label on the tasks themselves.
  const overrideLabel = isCapsule ? (
    <FormattedMessage id={comment.capsule_status === 'superseded' ?
      'supersededIntentDesignCapsule' : 'intentDesignCapsule'} />
  ) : (commentType === REPLY_TYPE ? (isDisplayOfSubTask ?
        <FormattedMessage id="commentGroupedTaskLabel" /> :
        <FormattedMessage id="issueReplyLabel" />) : (isInfo ? <FormattedMessage id="todoInfo" /> :
      (inNotesTab && isNote ? undefined :
        (inNotesTab && commentType === TODO_TYPE ? <FormattedMessage id="cardTypeLabelTask" /> :
          (isNote ? <FormattedMessage id="reportNote" /> :
            // A progress report in a wizard row otherwise falls through to the type chip's default
            // "Note" text - label it correctly (T-all-2249).
            (commentType === REPORT_TYPE && compressAll ? <FormattedMessage id="reportPresent" /> : undefined))))));
  const color = isMarketTodo ? myNotificationType : undefined;
  const displayUpdatedBy = updatedBy !== undefined && comment.updated_by !== comment.created_by;
  const showActions = (!replyBeingEdited || sortedReplies.length > 0) && !removeActions;
  const showHighlight = noHighlightId !== id && hashFragment?.includes(id);
  function getCommentHighlightStyle() {
    if (isInbox) {
      if (!inboxMessageId || inboxMessageId === id) {
        if (!isSent) {
          return classes.containerWhite;
        }
        return classes.containerBlueLink;
      }
      return classes.containerLink;
    }
    if (showHighlight) {
      return classes.containerHashYellow;
    }
    return classes.container;
  }

  function onNotificationTypeChange(event) {
    setOperationRunning(true);
    removeMessagesForCommentId(id, messagesState);
    const { value: notificationType } = event.target;
    return updateComment({marketId, commentId: id, notificationType})
      .then((comment) => {
        addCommentToMarket(comment, commentsState, commentsDispatch);
        setOperationRunning(false);
        navigate(history, formCommentLink(marketId, groupId, investibleId, id));
      }).finally(() => {
        setOperationRunning(false);
      });
  }

  function onViewChange(event) {
    const { value: newGroupId } = event.target;
    if (newGroupId === groupId) {
      return;
    }
    setOperationRunning(true);
    return alterComment(marketId, id, undefined, newGroupId)
      .then((movedComment) => {
        const marketComments = getMarketComments(commentsState, marketId, groupId);
        onCommentsMove([id], messagesState, marketComments, investibleId, commentsDispatch, marketId,
          [movedComment], messagesDispatch);
        setOperationRunning(false);
        navigate(history, formCommentLink(marketId, movedComment.group_id, investibleId, id));
      }).finally(() => {
        setOperationRunning(false);
      });
  }

  function moveToTask() {
    return updateComment(moveToTaskPayload(marketId, id, resolved)).then((taskComment) => {
      handleAcceptSuggestion({
        isMove: myPresenceIsAssigned && myPresence.id === comment.created_by &&
          isSingleAssisted(comments, assigned), comment: taskComment, investible, investiblesDispatch, marketStagesState,
        commentsState, commentsDispatch, messagesState
      });
      setOperationRunning(false);
      navigate(history, formCommentLink(marketId, taskComment.group_id, taskComment.investible_id, taskComment.id));
    });
  }

  // J-all-392: the Move drop down runs the wizard first step's final actions
  // directly, so mirror DecideWhereStep's stage fix when the move closes the
  // job's last open assistance.
  function fixInvestibleStageOnMove(updatedAt) {
    const investibleOpenComments = getOpenInvestibleComments(investibleId,
      investibleComments || getMarketComments(commentsState, marketId, groupId));
    const otherAssistance = investibleOpenComments.find((aComment) => aComment.id !== id &&
      [SUGGEST_CHANGE_TYPE, QUESTION_TYPE, ISSUE_TYPE].includes(aComment.comment_type));
    if (_.isEmpty(otherAssistance) && investible?.investible) {
      changeInvestibleStageOnCommentClose([marketInfo], investible.investible, investiblesDispatch,
        updatedAt, marketStagesState);
    }
  }

  function moveToDiscussionAction() {
    setOperationRunning(true);
    if (investibleId) {
      fixInvestibleStageOnMove(comment.updated_at);
    }
    return moveToDiscussion(comment, commentsState, commentsDispatch, setOperationRunning, history);
  }

  // Mirrors DecideWhereStep's moveToBug terminate for a blocker.
  function moveToBug() {
    setOperationRunning(true);
    return alterComment(marketId, id, 'RED')
      .then((response) => {
        addCommentToMarket(response, commentsState, commentsDispatch);
        const marketComments = getMarketComments(commentsState, marketId, groupId);
        const thread = marketComments.filter((aComment) => {
          return aComment.root_comment_id === id && aComment.id !== id;
        });
        const fixedThread = thread.map((aComment) => {
          return _.omit(aComment, 'investible_id');
        });
        addMarketComments(commentsDispatch, marketId, [...fixedThread]);
        if (investibleId) {
          fixInvestibleStageOnMove(comment.updated_at);
        }
        setOperationRunning(false);
        navigate(history, formCommentLink(marketId, groupId, undefined, id));
      });
  }

  const displayingDiff = showDiff && diff;
  const displayEditing = enableEditing && isEditable && !isInbox;
  if (loading) {
    return (
      <div className={classes.container}>
        <LoadingDisplay showMessage messageId="commentLoadingMessage" noMargin/>
      </div>
    )
  }

  const showMoveButton = isSent !== false
    && [TODO_TYPE, QUESTION_TYPE, SUGGEST_CHANGE_TYPE, ISSUE_TYPE].includes(commentType)
    && !inArchives && !removeActions && enableActions && marketType === PLANNING_TYPE;
  // Market-level bugs and notes/discussion can change view (T-all-2285) - jobs have their own switcher in the nav
  const marketGroups = _.sortBy((groupsState[marketId] || []).filter((group) => {
    const groupPresences = getGroupPresences(presences, groupPresencesState, marketId, group.id);
    return group.id === groupId || !_.isEmpty(groupPresences);
  }), 'name');
  const showViewSelect = !isCapsule && isSent !== false && enableEditing && !removeActions && !investibleId && groupId
    && [TODO_TYPE, QUESTION_TYPE, SUGGEST_CHANGE_TYPE, REPORT_TYPE].includes(commentType)
    && marketType === PLANNING_TYPE && _.size(marketGroups) > 1;
  // J-all-392 / S-all-227 / T-all-2455: Make task and Make bug on suggestions folded into the
  // Move drop down; a note keeps its own Make task button since notes have no Move.
  const showMakeTaskButton = isNote && !isCapsule;
  // T-all-2453: the Move button carries the choices of the wizard first step it
  // would have gone to, so the wizard opens past that step (or the final
  // choices run directly, exactly as the step's terminate buttons would).
  const isBugWizardMove = showMoveButton && !_.isEmpty(investibleId) &&
    [TODO_TYPE, SUGGEST_CHANGE_TYPE].includes(commentType);
  const moveBugWizardLink = `${formMarketAddInvestibleLink(marketId, groupId, undefined, typeObjectId,
    BUG_WIZARD_TYPE)}&fromCommentId=${id}`;
  const moveJobWizardLink = `${formMarketAddInvestibleLink(marketId, groupId, undefined,
    typeObjectId)}&fromCommentId=${id}`;
  function doesMoveTypeMatch(checkType) {
    return commentType === TODO_TYPE ? checkType === 'Task' :
      (commentType === SUGGEST_CHANGE_TYPE && ['Suggestion', 'Discussion'].includes(checkType));
  }
  let moveMenuItems = [];
  if (isBugWizardMove) {
    // BugDecisionStep's choices - S-all-227 puts Task first, keeping the
    // assigned user's direct conversion the Make task button had.
    // B-all-555: a suggestion's Task choice carries WhereDecisionStep's
    // current job or other job options directly instead of the wizard hop.
    moveMenuItems = ['Task', 'Suggestion', 'Discussion', 'Bug'].flatMap((checkType) => {
      const isSameType = doesMoveTypeMatch(checkType);
      if (checkType === 'Task' && !isSameType) {
        return [
          {
            id: `moveTaskLocal${id}`,
            label: <FormattedMessage id='TaskLocalMoveLabel' />,
            onClick: () => {
              setOperationRunning(true);
              return moveToTask();
            }
          },
          {
            id: `moveTaskOther${id}`,
            label: <FormattedMessage id='TaskOtherMoveLabel' />,
            onClick: () => navigate(history, `${moveJobWizardLink}&commentType=Task`)
          }
        ];
      }
      let onClick;
      if (checkType === 'Discussion') {
        onClick = moveToDiscussionAction;
      } else if (isSameType) {
        onClick = () => navigate(history, `${moveJobWizardLink}&commentType=${checkType}`);
      } else {
        onClick = () => navigate(history, `${moveBugWizardLink}&useType=${checkType}`);
      }
      return [{
        id: `move${checkType}${id}`,
        label: <FormattedMessage id={isSameType ? `${checkType}OtherMoveLabel` : `${checkType}Label`} />,
        onClick
      }];
    });
  } else if (showMoveButton) {
    // DecideWhereStep's choices, plus T-all-2455's Bug conversion for a view
    // level suggestion in place of the removed Make bug button.
    const isViewLevelBug = commentType === TODO_TYPE && _.isEmpty(investibleId);
    const isConvertibleToDiscussion = isViewLevelBug ||
      (!resolved && commentType === QUESTION_TYPE && !_.isEmpty(investibleId));
    moveMenuItems = [
      {
        id: `moveNewJob${id}`,
        label: <FormattedMessage id='JobWizardNewJob' />,
        onClick: () => navigate(history, `${moveJobWizardLink}&isNewJob=true`)
      },
      {
        id: `moveExistingJob${id}`,
        label: <FormattedMessage id='JobWizardExistingJob' />,
        onClick: () => navigate(history, `${moveJobWizardLink}&isNewJob=false`)
      }
    ];
    if (isConvertibleToDiscussion) {
      moveMenuItems.push({
        id: `moveDiscussion${id}`,
        label: <FormattedMessage id='DiscussionMoveLabel' />,
        onClick: moveToDiscussionAction
      });
    }
    if (commentType === ISSUE_TYPE) {
      moveMenuItems.push({
        id: `moveBug${id}`,
        label: <FormattedMessage id='BugMoveLabel' />,
        onClick: moveToBug
      });
    }
    if (commentType === SUGGEST_CHANGE_TYPE && _.isEmpty(investibleId)) {
      moveMenuItems.push({
        id: `moveBug${id}`,
        label: <FormattedMessage id='BugLabel' />,
        onClick: () => navigate(history, `${moveBugWizardLink}&useType=Bug`)
      });
    }
  }
  // T-all-2454: the Grouped buttons choose task or note up front so the wizard
  // no longer asks.
  const groupedBaseLink = formWizardLink(REPLY_WIZARD_TYPE, marketId, undefined, undefined, id, typeObjectId);
  function getGroupedMenuItems(isSubtaskLaunch) {
    const suffix = isSubtaskLaunch ? '&isSubtask=true' : '';
    return [
      {
        id: `groupedTask${id}`,
        label: <FormattedMessage id='commentTypeLabelSubTaskREPLY' />,
        onClick: () => navigate(history, `${groupedBaseLink}${suffix}&groupedType=${REPLY_TYPE}`)
      },
      {
        id: `groupedNote${id}`,
        label: <FormattedMessage id='commentTypeLabelREPORT' />,
        onClick: () => navigate(history, `${groupedBaseLink}${suffix}&groupedType=${REPORT_TYPE}`)
      }
    ];
  }
  const showConfigureVotingButton = commentType === QUESTION_TYPE && !inArchives &&
    !_.isEmpty(inlineInvestibles) && !resolved && !removeActions && (myPresence === createdBy || isAiAuthored);
  const showResolve = !isCapsule && isSent !== false && !inArchives && !removeActions && !resolved && !isInfo && (!isNote || !investibleId);
  const showReopen = !isCapsule && resolved && !inArchives && !removeActions && (commentType !== REPORT_TYPE || !investibleId);
  const showAddVoting = commentType === SUGGEST_CHANGE_TYPE && !inArchives && !resolved && !inlineMarketId
    && marketType === PLANNING_TYPE && !removeActions && !isSingleUser;
  const yourVote = myInlinePresence && myInlinePresence.investments &&
    myInlinePresence.investments.find((investment) => !investment.deleted);
  const showAbstain = enableActions && inlineMarketId && myPresence !== createdBy && !resolved &&
    !myInlinePresence.abstain && !yourVote && myMessage?.type === NOT_FULLY_VOTED_TYPE;
  const showUnmute = myInlinePresence.abstain && !resolved && enableActions && ([QUESTION_TYPE, SUGGEST_CHANGE_TYPE].includes(commentType));
  const showPokeAI = !isCapsule && enableEditing && isSent !== false && !beingEdited && !!comment.ticket_code &&
    isPokeAICommentType(commentType) && (!pokeAIMarketId || !!pokeAIParentTicketCode);
  const showSubTask = isTask && myPresence === createdBy;
  // On a task authored by someone else the single button stays a plain "Reply"; offer a separate
  // "Grouped" button beside it so a non-author can still open a grouped subtask or note.
  const showSubTaskButton = isTask && myPresence !== createdBy;
  const isDeletable = !isCapsule && !isInbox && !beingEdited;
  const linker =
    <div style={{marginRight: '1rem'}}>
      <InvesibleCommentLinker commentId={id} investibleId={investibleId} marketId={marketId} flushBottom
          textColor='black' hideLink={marketType === DECISION_TYPE} />
    </div>;
  const gravatarWithName = useCompression && inboxMessageId ?
    <Gravatar name={createdBy.name} email={createdBy.email} className={classes.smallGravatar}/>
    : <GravatarAndName key={myPresence.id} email={createdBy.email}
                                            name={createdBy.name} typographyVariant="caption"
                                            typographyClassName={classes.createdBy}
                                            avatarClassName={classes.smallGravatar}
  />;
  const showLinker = !isInbox && !beingEdited && ![JUSTIFY_TYPE, REPLY_TYPE].includes(commentType);
  const notificationMessage = !replyEditId && myMessage?.type_object_id && !isInbox &&
  (investibleId || commentType !== TODO_TYPE || myMessage.type !== UNASSIGNED_TYPE) ? myMessage : undefined;
  const linkerShouldBeFirst = noAuthor && commentType === TODO_TYPE && investibleId;
  // A TODO comment with no investible_id is a view-level bug - its type chip
  // must read "Bug", not "Task" (B-all-549).
  const bugSubtype = commentType === TODO_TYPE && _.isEmpty(investibleId) ? BUG : undefined;
  const cardTypeDisplay = overrideLabel ? (
    <CardType className={classes.commentType} type={commentType} resolved={resolved} compact
              subtype={bugSubtype || (commentType === REPLY_TYPE ?
                TODO_TYPE : (isNote ? NOTE :undefined))} linker={(reallyNoAuthor || isMarketTodo) && showLinker && linker}
              label={overrideLabel} color={color} compressed={useCompression} notificationMessage={notificationMessage}
              reserveNotificationSpace
              gravatar={noAuthor || mobileLayout || isDisplayOfSubTask ? undefined : gravatarWithName}
    />
  ): (
    <CardType className={classes.commentType} type={commentType} resolved={resolved} compact compressed={useCompression}
              subtype={bugSubtype}
              gravatar={noAuthor || mobileLayout ? undefined : gravatarWithName} notificationMessage={notificationMessage}
              reserveNotificationSpace
              alwaysShowTypeChip={compressAll}
              linker={(linkerShouldBeFirst || reallyNoAuthor || isMarketTodo) && showLinker && linker}
    />
  );
  const commentTypeChip = <CommentTypeChip type={commentType} subtype={bugSubtype} resolved={resolved}
                                           mobileLayout={mobileLayout}
                                           label={isCapsule ? overrideLabel :
                                             (commentType === REPORT_TYPE && !isNote ?
                                               <FormattedMessage id="reportPresent" /> : undefined)} />;
  const deleteWizardBaseLink = formWizardLink(DELETE_COMMENT_TYPE, marketId, undefined,
    undefined, id);
  const dateInfo = <>
    {mobileLayout && (
      <Typography className={classes.timeElapsed} variant="body2">
        {formatCommentDate(intl, comment, inNotesTab)}
      </Typography>
    )}
    {!mobileLayout && (
      <Typography className={classes.timeElapsed} variant="body2" style={{paddingLeft: '1rem'}}>
        Created <UsefulRelativeTime value={comment.created_at}/>
        {noAuthor && !reallyNoAuthor &&
          `${intl.formatMessage({ id: 'lastUpdatedBy' })} ${createdBy.name}`}.
        {comment.created_at < comment.updated_at && !resolved && mediumLayout && (
          <> Updated <UsefulRelativeTime value={comment.updated_at}/></>
        )}
        {resolved && mediumLayout && (
          <> Resolved <UsefulRelativeTime value={comment.updated_at}/></>
        )}
        {comment.created_at < comment.updated_at && !displayUpdatedBy && mediumLayout && (
          <>.</>
        )}
        {displayUpdatedBy && mediumLayout &&
          `${intl.formatMessage({ id: 'lastUpdatedBy' })} ${updatedBy.name}.`}
      </Typography>
    )}
  </>;
  const endActions = <>{showConfigureVotingButton && (
    <SpinningIconLabelButton
      onClick={() => navigate(history, formWizardLink(JOB_COMMENT_CONFIGURE_WIZARD_TYPE, marketId,
        undefined, undefined, id, typeObjectId))}
      doSpin={false} icon={SettingsIcon} iconOnly={mobileLayout}>
      {!mobileLayout && intl.formatMessage({ id: 'configureVoting' })}
    </SpinningIconLabelButton>
  )}
  {showMakeTaskButton && !mobileLayout && (
    <SpinningIconLabelButton
      onClick={() => {
        if (myPresenceIsAssigned) {
          return moveToTask();
        }
        navigate(history, `${formMarketAddInvestibleLink(marketId, groupId, undefined, 
          typeObjectId, BUG_WIZARD_TYPE)}&fromCommentId=${id}&useType=Task`);
      }}
      id={`makeTask${id}`}
      doSpin={myPresenceIsAssigned}
      icon={ListAltIcon}
      focus={focusMove}
    >
      {intl.formatMessage({ id: 'makeTask' })}
    </SpinningIconLabelButton>
  )}
  {showMoveButton && !mobileLayout && (
    <MenuButton items={moveMenuItems}>
      <SpinningIconLabelButton
        id={`moveComment${id}`}
        doSpin={false}
        icon={Eject}
        endIcon={<ExpandMoreIcon htmlColor='black' />}
        focus={focusMove}
      >
        {intl.formatMessage({ id: "storyFromComment" })}
      </SpinningIconLabelButton>
    </MenuButton>
  )}
  {((resolved && showReopen) || (!resolved && showResolve)) && !mobileLayout && (
    <SpinningIconLabelButton
      doSpin={resolved || commentType !== REPORT_TYPE || !investibleId}
      onClick={resolved ? reopen : (commentType === REPORT_TYPE && investibleId ? () => navigate(history,
        `${formInvestibleAddCommentLink(JOB_COMMENT_WIZARD_TYPE, investibleId, marketId,
          REPORT_TYPE)}&resolveId=${id}`) : resolve)}
      icon={resolved ? SettingsBackupRestore : Done}
      id={`commentResolveReopenButton${id}`}
      toolTipId={!resolved && isDelegate ? 'commentDelegateExplanation' : undefined}
    >
      {intl.formatMessage({ id: resolved ? 'commentReopenLabel' :
          (isDelegate ? 'commentDelegateLabel' : 'commentResolveLabel') })}
    </SpinningIconLabelButton>
  )}
  {diff && (
    <SpinningIconLabelButton icon={showDiff ? ExpandLess : ExpandMoreIcon} iconOnly={mobileLayout}
                             onClick={(event) => toggleDiffShow(event)}
                             doSpin={false}>
      {!mobileLayout && intl.formatMessage({ id: showDiff ? 'diffDisplayDismissLabel' : 'diffDisplayShowLabel'})}
    </SpinningIconLabelButton>
  )}</>;
  const commentCard = <div style={{overflow: 'unset', backgroundColor: showHighlight ? undefined : (isDark ? DARK_TEXT_BACKGROUND_COLOR : 'white'),
    borderRadius: '8px', marginTop: isSent === false || usePadding === false ? 0
      : '1rem', width: removeActions ? '100%' : undefined, maxWidth: removeActions ? '98%' : undefined}}
                            className={getCommentHighlightStyle()}
                            ref={editBox}>
    <div onClick={(event) => {
      if (!invalidEditEvent(event)) {
        if (isInbox && isSent) {
          navigate(history, formCommentLink(marketId, groupId, investibleId, id));
        }
      }
    }}>
      {/* T-all-2220: rationalize the header top row so the type chip, author, timestamp, edit
          pencil, short code and delete icon all share one vertical center line. The row centers its
          children (alignItems:'center'); the commentType class no longer pins the chip to the top
          (alignSelf:'start' removed) and the author block no longer carries an asymmetric 10px
          bottom margin, both of which used to ride above the centered cluster. The cluster gets its
          own alignItems:'center' flex so its items line up regardless of individual button sizes.
          The small paddingLeft gives the otherwise flush-left type chip a left inset that matches
          the top breathing room it gets from the centered row. */}
      <div style={{display: 'flex', alignItems: 'center', paddingLeft: '0.375rem'}}>
        {cardTypeDisplay}
        <div style={{flexGrow: 1}}/>
        <div style={{display: 'flex', alignItems: 'center'}}>
        {(beingEdited || ![JUSTIFY_TYPE, REPLY_TYPE].includes(commentType)) && dateInfo}
        {isInbox && isSent && (
          // T-all-2217: a single comment shown expanded (inboxMessageId === id, small body)
          // renders this full card instead of the compressedCommentCard, so it was missing the
          // explicit click-through affordance T-all-2181 added there. The card already navigates
          // to the comment on click (isInbox && isSent), so back its blue outline with the same
          // "open" icon.
          <TooltipIconButton
            lightSurface
            icon={<OpenInNewIcon style={{ marginLeft: '0.5rem', marginRight: '1rem' }}
                                 htmlColor={theme.palette.type === 'dark' ? 'black' : '#2F80ED'} />}
            onClick={(event) => {
              preventDefaultAndProp(event);
              navigate(history, formCommentLink(marketId, groupId, investibleId, id));
            }}
            size="small"
            noPadding
            translationId="rowOpenComment"
          />
        )}
        {displayEditing && !beingEdited && (
          <TooltipIconButton
            lightSurface
            onClick={toggleEdit}
            icon={<Edit fontSize='small' style={{marginRight: '1rem'}} htmlColor={ACTION_BUTTON_COLOR} />}
            translationId="edit"
          />
        )}
        {showLinker && !linkerShouldBeFirst && !reallyNoAuthor && !isMarketTodo && linker}
        {!isCapsule && isMyPokableComment(comment, presences, groupPresencesState, marketId) && enableActions && isEditable && !beingEdited && (
          <TooltipIconButton
            lightSurface
            disabled={operationRunning !== false}
            onClick={(event) => {
              preventDefaultAndProp(event);
              setOperationRunning(true);
              return getMarketClient(marketId).then((client) => client.users.pokeComment(comment.id).then(() => setOperationRunning(false)));
            }}
            icon={<NotificationsActive fontSize='small' htmlColor={theme.palette.type === 'dark' ? DARK_INFO_COLOR : undefined} /> }
            size='small'
            translationId='poke'
            doFloatRight
            noAlign
          />
        )}
        {showPokeAI && (
          <PokeAIButton
            marketId={pokeAIMarketId || marketId}
            ticketCode={comment.ticket_code}
            parentTicketCode={pokeAIParentTicketCode}
            id={`pokeAI${id}`}
            iconOnly
            lightSurface
            noAlign
          />
        )}
        {enableActions && isDeletable && (
          <div style={{marginRight: '2rem'}}>
            <TooltipIconButton
              lightSurface
              disabled={operationRunning !== false}
              onClick={() => {
                // J-all-325 (T-all-2197): open delete inline when inside a container that supports it.
                if (openInlineWizard && !isInbox) {
                  openInlineWizard({ wizardType: DELETE_COMMENT_TYPE, marketId, commentId: id });
                } else if (isInbox) {
                  navigate(history, `${deleteWizardBaseLink}&isInbox=${isInbox}`);
                } else {
                  navigate(history, deleteWizardBaseLink);
                }
              }}
              icon={<NotificationDeletion isRed={operationRunning === false} />}
              size="small"
              translationId="commentRemoveLabel"
            />
          </div>
        )}
        </div>
      </div>
      {/* T-all-2209 (C-all-1013/C-all-1015): make the whole comment body a click-to-edit
          target with the pointer cursor, not just the text glyphs. The header buttons and the
          footer CardActions are siblings outside this CardContent so they stay excluded, and
          setBeingEdited's invalidEditEvent guard still skips link clicks and text selection.
          Only when this comment is editable and not already being edited. */}
      <CardContent className={classes.cardContent}
        style={(displayEditing && !isReallyMobileLayout && !thisCommentBeingEdited)
          ? { cursor: 'pointer' } : undefined}
        onClick={(displayEditing && !isReallyMobileLayout && !thisCommentBeingEdited)
          ? setBeingEdited : undefined}>
        {!noAuthor && mobileLayout && !beingEdited && (
          <GravatarAndName
            key={myPresence.id}
            email={createdBy.email}
            name={createdBy.name}
            typographyVariant="caption"
            typographyClassName={classes.createdBy}
            avatarClassName={classes.smallGravatar}
          />
        )}
        <Box marginTop={1}>
          {!thisCommentBeingEdited && !displayingDiff && !_.isEmpty(comment) && (
            <ReadOnlyQuillEditor value={body} setBeingEdited={setBeingEdited}
                                 noOverflow={isInbox}
                                 id={isInbox ? `inboxComment${id}` : id}
                                 isEditable={!isReallyMobileLayout && displayEditing}/>
          )}
          {!thisCommentBeingEdited && displayingDiff && (
            <DiffDisplay id={id} />
          )}
          {!thisCommentBeingEdited && !showActions && diff && (
            <SpinningIconLabelButton icon={showDiff ? ExpandLess : ExpandMoreIcon} iconOnly={mobileLayout}
                                     onClick={(event) => toggleDiffShow(event)}
                                     doSpin={false}>
              {!mobileLayout && intl.formatMessage({ id: showDiff ? 'diffDisplayDismissLabel' : 'diffDisplayShowLabel'})}
            </SpinningIconLabelButton>
          )}
          {thisCommentBeingEdited && (
            <CommentEdit
              marketId={marketId}
              comment={comment}
              isDisplayOfSubTask={isDisplayOfSubTask}
              onSave={toggleEdit}
              onCancel={toggleEdit}
              editState={editState}
              updateEditState={updateEditState}
              editStateReset={editStateReset}
              myNotificationType={myNotificationType}
              isInReview={createdInReview}
              messages={myMessage ? [myMessage] : []}
            />
          )}
        </Box>
      </CardContent>
      {!thisCommentBeingEdited && useCompression === false && (
        <CardActions>
          <div className={classes.actions}>
            <SpinningIconLabelButton
              icon={ExpandLess}
              toolTipId='commentCloseThreadLabelExplanation'
              doSpin={false}
              onClick={(event) => {
                preventDefaultAndProp(event);
                toggleCompression();
              }}
            >
              {intl.formatMessage({ id: 'commentCloseThreadLabel'})}
            </SpinningIconLabelButton>
          </div>
        </CardActions>
      )}
      {showActions && !thisCommentBeingEdited && (
        <CardActions>
          <div className={classes.actions}>
            {((resolved && showReopen) || (!resolved && showResolve)) && mobileLayout && (
              <SpinningIconLabelButton
                doSpin={resolved || commentType !== REPORT_TYPE || !investibleId}
                onClick={resolved ? reopen : (commentType === REPORT_TYPE && investibleId ? () => navigate(history,
                  `${formInvestibleAddCommentLink(JOB_COMMENT_WIZARD_TYPE, investibleId, marketId,
                    REPORT_TYPE)}&resolveId=${id}`) : resolve)}
                icon={resolved ? SettingsBackupRestore : Done}
                id={`commentResolveReopenButton${id}`}
                iconOnly={!resolved}
                toolTipId={!resolved && isDelegate ? 'commentDelegateExplanation' : undefined}
                aria-label={intl.formatMessage({ id: resolved ? 'commentReopenLabel' :
                    (isDelegate ? 'commentDelegateLabel' : 'commentResolveLabel') })}
              >
                {resolved && intl.formatMessage({ id: resolved ? 'commentReopenLabel' :
                    'commentResolveLabel' })}
              </SpinningIconLabelButton>
            )}
            {commentType === TODO_TYPE && investibleId && !removeActions && enableEditing && !inBacklog && (
              <FormControlLabel
                id='inProgressCheckbox'
                className={classes.formControlLabel}
                style={{color: 'black', alignSelf: 'center', marginLeft: '4px'}}
                control={
                  <Checkbox
                    classes={{
                      root: classes.rootCheckbox,
                      checked: classes.checkedCheckbox,
                    }}
                    id={`inProgressCheckbox${id}`}
                    checked={operationRunning === `inProgressCheckbox${id}` ? !inProgress : inProgress}
                    onClick={handleToggleInProgress}
                    disabled={!myPresenceIsAssigned || removeActions || operationRunning !== false}
                  />
                }
                label={intl.formatMessage({ id: 'inProgress' })}
              />
            )}
            {/* T-all-2454: in Grouped mode the button asks task or note up front */}
            {isSent !== false && enableEditing && !removeActions && showSubTask && (
              <MenuButton items={getGroupedMenuItems(false)}>
                <SpinningIconLabelButton
                  icon={AddIcon}
                  iconOnly={mobileLayout}
                  id={`commentReplyButton${id}`}
                  doSpin={false}
                  endIcon={mobileLayout ? undefined : <ExpandMoreIcon htmlColor='black' />}
                >
                  {!mobileLayout && intl.formatMessage({ id: 'commentSubTaskLabel' })} {hasReply(comment) && <EditIcon htmlColor={ACTION_BUTTON_COLOR} />}
                </SpinningIconLabelButton>
              </MenuButton>
            )}
            {isSent !== false && enableEditing && !removeActions && !showSubTask && (
              <SpinningIconLabelButton
                onClick={() => navigate(history, formWizardLink(REPLY_WIZARD_TYPE, marketId,
                  undefined, undefined, id, typeObjectId))}
                icon={thisIsMyNote ? AddIcon : ReplyIcon}
                iconOnly={mobileLayout}
                id={`commentReplyButton${id}`}
                doSpin={false}
              >
                {!mobileLayout && intl.formatMessage({ id: thisIsMyNote ? 'addNote' : 'commentReplyLabel' })} {hasReply(comment) && <EditIcon htmlColor={ACTION_BUTTON_COLOR} />}
              </SpinningIconLabelButton>
            )}
            {isSent !== false && enableEditing && !removeActions && showSubTaskButton && (
              <MenuButton items={getGroupedMenuItems(true)}>
                <SpinningIconLabelButton
                  icon={AddIcon}
                  iconOnly={mobileLayout}
                  id={`commentSubTaskButton${id}`}
                  doSpin={false}
                  endIcon={mobileLayout ? undefined : <ExpandMoreIcon htmlColor='black' />}
                >
                  {!mobileLayout && intl.formatMessage({ id: 'commentSubTaskLabel' })}
                </SpinningIconLabelButton>
              </MenuButton>
            )}
            {/* On someone else's note the single button stays a plain "Reply"; offer a separate
                "Note" button beside it so a non-author can create a sub note the way AI does. */}
            {isSent !== false && enableEditing && !removeActions && isNote && !isCapsule && !thisIsMyNote && (
              <SpinningIconLabelButton
                onClick={() => navigate(history, `${formWizardLink(REPLY_WIZARD_TYPE, marketId,
                  undefined, undefined, id, typeObjectId)}&isNote=true`)}
                icon={AddIcon}
                iconOnly={mobileLayout}
                id={`commentSubNoteButton${id}`}
                doSpin={false}
              >
                {!mobileLayout && intl.formatMessage({ id: 'addNote' })}
              </SpinningIconLabelButton>
            )}
            {isSent !== false && isTask && resolved && enableActions && (
              <SpinningIconLabelButton
                onClick={() => navigate(history, formWizardLink(REPLY_WIZARD_TYPE, marketId,
                  undefined, undefined, id, typeObjectId))}
                icon={AddIcon}
                iconOnly={mobileLayout}
                id={`commentAddNoteButton${id}`}
                doSpin={false}
              >
                {!mobileLayout && intl.formatMessage({ id: 'addNote' })}
              </SpinningIconLabelButton>
            )}
            {!isCapsule && (!investibleId || isNote) && !removeActions && !mobileLayout && (
              <FormControlLabel
                id='isVisibleCheckbox'
                className={classes.formControlLabel}
                style={{color: 'black', alignSelf: 'center', marginLeft: '4px'}}
                control={
                  <Checkbox
                    id={`isVisibleCheckbox${id}`}
                    checked={noteHasReply ? true : (operationRunning === `isVisibleCheckbox${id}` ? !isVisible : isVisible)}
                    classes={{
                      root: classes.rootCheckbox,
                      checked: classes.checkedCheckbox,
                    }}
                    onClick={handleToggleIsVisible}
                    disabled={noteHasReply || operationRunning !== false}
                  />
                }
                label={intl.formatMessage({ id: isNote ? 'isVisibleCheckboxExplanation' : 'isAIAbleExplanation' })}
              />
            )}
            {enableEditing && !removeActions && commentType === TODO_TYPE && !investibleId && (
              <FormControl size='small' style={{marginRight: '1rem', alignSelf: 'center'}}>
                <Select
                  value={myNotificationType}
                  classes={{
                    icon: classes.selectIcon
                  }}
                  onChange={onNotificationTypeChange}
                  onClick={(event) => event.stopPropagation()}
                  style={{color: 'black'}}
                  // Standard-variant Select pads 3px top / 7px bottom (bottom reserved
                  // for the underline), which lifts the text ~2px above center. Rebalance
                  // to 5px/5px (same total height, same underline) so the value lines up
                  // vertically with the adjacent Reply/Move/Resolve pills.
                  SelectDisplayProps={{ style: { paddingTop: '5px', paddingBottom: '5px' } }}
                  // The dark theme forces every menu paper to #1e1e1e, which clashes with
                  // the (light) bug card. Match the dropdown menu to the card background and
                  // keep the text black, consistent with the card and the value shown above.
                  MenuProps={{
                    PaperProps: {
                      style: { backgroundColor: isDark ? DARK_TEXT_BACKGROUND_COLOR : 'white', color: 'black' }
                    }
                  }}
                >
                  <MenuItem value='RED'>
                    {intl.formatMessage({ id: 'immediate' })}
                  </MenuItem>
                  <MenuItem value='YELLOW'>
                    {intl.formatMessage({ id: 'able' })}
                  </MenuItem>
                  <MenuItem value='BLUE'>
                    {intl.formatMessage({ id: 'convenient' })}
                  </MenuItem>
                </Select>
              </FormControl>
            )}
            {showViewSelect && (
              <FormControl size='small' style={{marginRight: '1rem', alignSelf: 'center'}}>
                <Select
                  value={groupId}
                  classes={{
                    icon: classes.selectIcon
                  }}
                  onChange={onViewChange}
                  onClick={(event) => event.stopPropagation()}
                  style={{color: 'black'}}
                  // Same padding rebalance and menu paper treatment as the severity dropdown above
                  SelectDisplayProps={{ style: { paddingTop: '5px', paddingBottom: '5px' } }}
                  MenuProps={{
                    PaperProps: {
                      style: { backgroundColor: isDark ? DARK_TEXT_BACKGROUND_COLOR : 'white', color: 'black' }
                    }
                  }}
                >
                  {marketGroups.map((group) => (
                    <MenuItem key={`view${group.id}`} value={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {showAddVoting && (
              <SpinningIconLabelButton
                onClick={() => navigate(history, formWizardLink(JOB_COMMENT_CONFIGURE_WIZARD_TYPE, marketId,
                  undefined, undefined, id, typeObjectId))} iconOnly={mobileLayout}
                doSpin={false} icon={ThumbsUpDownIcon}>
                {!mobileLayout && intl.formatMessage({ id: 'addVoting' })}
              </SpinningIconLabelButton>
            )}
            {inlineMarket.market_type === DECISION_TYPE && enableEditing && !removeActions && (
              <SpinningIconLabelButton
                doSpin={false}
                onClick={() => navigate(history, formWizardLink(OPTION_WIZARD_TYPE, inlineMarketId,
                  undefined, undefined, undefined, typeObjectId))}
                icon={AddIcon}
                iconOnly={mobileLayout}
                id={`addOptionButton${id}`}
              >
                {!mobileLayout && intl.formatMessage({ id: 'inlineAddLabel' })}
              </SpinningIconLabelButton>
            )}
            {showAbstain && (
              <SpinningIconLabelButton
                onClick={() => abstain(true)}
                icon={NotInterested}
                iconOnly={mobileLayout}
                id={`commentAbstainButton${id}`}
              >
                {!mobileLayout && intl.formatMessage({ id: 'commentAbstainLabel' })}
              </SpinningIconLabelButton>
            )}
            {showUnmute && (
              <SpinningIconLabelButton
                onClick={() => abstain(false)}
                icon={NotificationsActive}
                iconOnly={mobileLayout}
                id={`commentUnmuteButton${id}`}
              >
                {!mobileLayout && intl.formatMessage({ id: 'commentUnmuteLabel' })}
              </SpinningIconLabelButton>
            )}
            {showMoveButton && mobileLayout && (
              <MenuButton items={moveMenuItems}>
                <SpinningIconLabelButton
                  doSpin={false}
                  iconOnly={true}
                  icon={Eject}
                />
              </MenuButton>
            )}
            {endActions}
          </div>
        </CardActions>
      )}
    </div>
  </div>
  let strippedBody = stripHTML(body);
  if (_.isEmpty(strippedBody)) {
    strippedBody = dateInfo;
  }
  const associatedComments = investibleComments?.filter(comment => comment.associated_comment_id === id);
  // Type-chip card for the compressed comment (T-all-2178 / Q-all-133 O-3): a
  // clean full-width card with the comment type chip on the left (the same
  // CardType chip the reply / uncompressed view shows, C-all-986), the body,
  // and an expand chevron - instead of the cramped avatar + name row.
  const compressedCommentCard = <div className={getCommentHighlightStyle()}
  style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '9px 12px',
    backgroundColor: showHighlight ? undefined : (theme.palette.type === 'dark' ? DARK_TEXT_BACKGROUND_COLOR : 'white'),
    cursor: 'pointer', width: '100%', maxWidth: '98%', marginTop: isSent === false || usePadding === false ? 0
      : '1rem' }} onClick={(event) => {
        if (!invalidEditEvent(event)) {
          if (isInbox) {
            navigate(history, formCommentLink(marketId, groupId, investibleId, id));
          } else {
            toggleCompression();
          }
        }
      }}>
    {commentTypeChip}
    <div className={classes.compressedComment} style={{ paddingLeft: 0, paddingTop: 0, marginTop: 0 }}>
      {strippedBody}</div>
    {isInbox && (
      // Explicit click-through affordance (T-all-2181, Q-all-154 O-1 / Q-1):
      // in wizards/inbox the row navigates to the full comment, so back the
      // blue outline up with an "open" icon. Distinct from the expand chevron
      // below, which only expands the comment in place.
      <TooltipIconButton
        lightSurface
        icon={<OpenInNewIcon htmlColor={theme.palette.type === 'dark' ? 'black' : '#2F80ED'} />}
        onClick={(event) => {
          preventDefaultAndProp(event);
          navigate(history, formCommentLink(marketId, groupId, investibleId, id));
        }}
        size="small"
        noPadding
        translationId="rowOpenComment"
      />
    )}
    <TooltipIconButton
      lightSurface
      icon={<ExpandMoreIcon htmlColor={theme.palette.type === 'dark' ? 'black' : undefined} />}
      onClick={(event) => {
        preventDefaultAndProp(event);
        toggleCompression();
      }}
      size="small"
      noPadding
      translationId="rowExpandComment"
    />
  </div>;
  if (useCompression && (compressAll || inboxMessageId !== id)) {
    const numInThread = _.size(comments.filter((aComment) => aComment.root_comment_id === id &&
      aComment.id !== id));
    return (
    <>
      {inboxMessageId !== id ? compressedCommentCard :
        (isLargeDisplay(body, COMPRESSED_PREVIEW_LINES) ? compressedCommentCard  : commentCard)}
      <LocalCommentsContext.Provider value={{
        comments, marketId, idPrepend, pokeAIMarketId,
        pokeAIParentTicketCode: pokeAIParentTicketCode ||
          (investibleId ? undefined : comment.ticket_code)
      }}>
        {inboxMessageId === id && numInThread > 0 &&
          getCompressionButton(numInThread, id, toggleCompression, intl)
        }
        {inboxMessageId !== id && sortedReplies.map(child => {
          const parent = findParentInDescendants(child, inboxMessageId, comments);
          if (parent) {
            const numberHidden = calculateNumberHidden(comment, inboxMessageId, comments, parent);
            return (
              <>
                <div style={{marginBottom: numberHidden === 0 ? '15px' : undefined}} />
                <InitialReply
                  key={parent.id}
                  comment={parent}
                  marketId={marketId}
                  enableEditing={enableEditing}
                  enableActions={enableActions}
                  isDeletable={isDeletable}
                  replyEditId={replyEditId}
                  inboxMessageId={inboxMessageId}
                  useCompression
                  toggleCompression={toggleCompression}
                  numberHidden={numberHidden}
                  isInbox={isInbox}
                  myPresenceIsAssigned={myPresenceIsAssigned}
                  wizardProps={wizardProps}
                />
              </>
            );
          }
          return React.Fragment;
        })}
      </LocalCommentsContext.Provider>
      {getDecision(inlineMarketId)}
    </>
    );
  }
  const threadSize = calculateNumberHidden(comment, undefined, comments, undefined);
  return (
    <div style={{paddingLeft: usePadding && !beingEdited ? '0.5rem' : undefined, width: '98%'}}>
      {commentCard}
      {useCompression && threadSize > 0 && (
        <IconButton id={`removeCompressed${id}`} onClick={toggleCompression}
                    style={{border: '1px solid grey', marginTop: -7}}>
          <Tooltip key={`tipCompressed${id}`}
                   title={intl.formatMessage({ id: 'removeCompressionExplanation' })}>
            <StyledBadge
              badgeContent={threadSize}
              style={{paddingRight: '7px'}} >
              <UnfoldMore />
            </StyledBadge>
          </Tooltip>
        </IconButton>
      )}
      {showNotes && !_.isEmpty(associatedComments) && (
        <div style={{marginTop: '1rem'}}>
          <CondensedTodos
            comments={associatedComments}
            investibleComments={investibleComments}
            marketId={marketId}
            hideTabs
            isDefaultOpen
            hideTitle
            showChecked={false}
          />
        </div>
      )}
      {!useCompression && (
        <Box marginTop={1} paddingX={1} className={classes.childWrapper}>
          <LocalCommentsContext.Provider value={{
            comments, marketId, idPrepend, pokeAIMarketId,
            pokeAIParentTicketCode: pokeAIParentTicketCode ||
              (investibleId ? undefined : comment.ticket_code)
          }}>
            {sortedReplies.map(child => {
              const { id: childId } = child;
              return (
                <InitialReply
                  key={childId}
                  comment={child}
                  marketId={marketId}
                  enableEditing={enableEditing}
                  enableActions={enableActions}
                  isDeletable={isDeletable}
                  replyEditId={replyEditId}
                  inboxMessageId={inboxMessageId}
                  isInbox={isInbox}
                  myPresenceIsAssigned={myPresenceIsAssigned}
                  wizardProps={wizardProps}
                />
              );
            })}
          </LocalCommentsContext.Provider>
        </Box>
      )}
      {getDecision(inlineMarketId)}
    </div>
  );
}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  noAuthor: PropTypes.bool,
  comments: PropTypes.arrayOf(PropTypes.object).isRequired,
  marketId: PropTypes.string.isRequired,
  pokeAIMarketId: PropTypes.string,
  pokeAIParentTicketCode: PropTypes.string
};

const unknownPresence = {
  name: "unknown",
  email: ""
};

function useCommenter(comment, presences) {
  return presences.find(presence => presence.id === comment.created_by);
}

function useUpdatedBy(comment, presences) {
  return presences.find(presence => presence.id === comment.updated_by);
}

export default Comment;
